"use client";

import React from "react";
import { CaseStudyData } from "../../data/case-studies/types";

interface CaseStudyDecisionsProps {
  caseStudy: CaseStudyData;
}

export function CaseStudyDecisions({ caseStudy }: CaseStudyDecisionsProps) {
  if (!caseStudy.decisions || caseStudy.decisions.length === 0) return null;

  return (
    <section className="py-24 md:py-36 border-b border-white/[0.08]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {/* Section Header */}
        <div className="mb-16 space-y-3">
          <span className="block font-mono text-xs uppercase tracking-wider text-zinc-500">
            System Decisions
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white">
            Architectural Trade-Offs
          </h2>
        </div>

        {/* Pure Swiss Editorial Decision Rows with 1px Hairlines */}
        <div className="divide-y divide-white/[0.08] border-t border-b border-white/[0.08]">
          {caseStudy.decisions.map((dec, idx) => (
            <div
              key={idx}
              className="py-10 md:py-14 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start"
            >
              
              {/* Left 4 Cols: Index & Decision Name */}
              <div className="lg:col-span-5 space-y-3">
                <span className="font-mono text-xs text-zinc-600 block">
                  0{idx + 1}
                </span>
                <h3 className="text-xl sm:text-2xl font-semibold text-white tracking-tight leading-snug">
                  {dec.decision}
                </h3>

                {dec.alternativesRejected && dec.alternativesRejected.length > 0 && (
                  <div className="pt-2">
                    <span className="font-mono text-xs text-zinc-500">
                      Superseded: {dec.alternativesRejected.join(" • ")}
                    </span>
                  </div>
                )}
              </div>

              {/* Right 7 Cols: Detailed Engineering Rationale */}
              <div className="lg:col-span-7">
                <p className="text-base sm:text-lg text-zinc-400 font-light leading-relaxed">
                  {dec.rationale}
                </p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
